import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LoadingCondomob from '../../../components/LoadingCondomob';
import Tabs from '../../../components/Tabs';

import Open from './Open';
import Paid from './Paid';
import Config from './Config';

import { Container, TitleContainer, TitleBackButton, Title } from './styles';

const CopyTicket: React.FC = () => {
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const { t } = useTranslation();

  const state = history.location.state || {};
  const activeTab = state.activeTab !== undefined ? state.activeTab : 0;

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <Container className="containerDefault">
          <LoadingCondomob />
        </Container>
      ) : (
        <Container className="containerDefault">
          <TitleContainer>
            <TitleBackButton
              onClick={() => {
                history.replace({
                  pathname: '/dashboard',
                });
              }}
            >
              <FontAwesomeIcon icon={['far', 'angle-left']} />
              {`${t('common.words.back')}`}
            </TitleBackButton>
            <Title>{`${t('tickets.title')}`}</Title>
          </TitleContainer>
          <Tabs
            tabElement={[
              {
                tabTitle: `${t('tickets.copyTickets.tabs.tab01')}`,
                tabIcon: 'file-alt',
              },
              {
                tabTitle: `${t('tickets.copyTickets.tabs.tab02')}`,
                tabIcon: 'file-check',
              },
              {
                tabTitle: `${t('tickets.copyTickets.tabs.tab03')}`,
                tabIcon: 'cog',
              },
            ]}
            tabContentItem={[Open, Paid, Config]}
            tabActive={activeTab}
          />
        </Container>
      )}
    </>
  );
};

export default CopyTicket;
